import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { LogoComponent } from '../../components/logo/logo.component';

@Component({
    selector: 'app-privacy',
        standalone: true,
templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    imports: [LogoComponent]
})
export class PrivacyComponent {

  DefualtPath =environment.wordpressUrl

}
